import Axios from 'axios'
import  common from './modules/common'

const modules = [common]

class Fetch {
    getData(config) {
        const instance = Axios.create(config)

        instance.interceptors.request.use(...config.reqInterceptor)
        instance.interceptors.response.use(...config.repInterceptor)

        return instance(config).finally(() => '')
    }
}

modules.forEach(_module => {
    for (let [fnName, fn] of Object.entries(_module)) {
        Fetch.prototype[fnName] = fn
    }
})

export default {
    fetch: new Fetch(),
    install: Vue => {
        Vue.prototype.$fetch = new Fetch()
    }
}
